/**
 * Dropdown panel styling for zestlife avatar menu and matching Select menus.
 * Still consumed as an MUI `sx` object by PostSignUpSurveyDialog; the nav bar
 * itself replicates these values with Tailwind classes in shared/Menu.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export const ZESTLIFE_MENU_PAPER_SX = {
  "&&": {
    borderRadius: "16px",
    minWidth: 232,
    maxWidth: 400,
    backgroundColor: "#ffffff",
    color: "text.primary",
    border: "0.5px solid",
    borderColor: "divider",
    boxShadow: "0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)",
  },
  "& .MuiMenu-list": {
    padding: 0,
  },
}

/** Matches `zestlife_dropdown_white.html` reference (brand blue #18B4E8). */
export const ZESTLIFE_BLUE = "#18B4E8"
/** Same as HTML mock: #18B4E8 at opacity 0.7 on icon strokes/fills */
export const ZESTLIFE_BLUE_AT_70 = "rgba(24, 180, 232, 0.7)"
export const ZESTLIFE_BLUE_SOFT_BG = "#E6F7FC"
/** rgba(24,180,232,0.18) */
export const ZESTLIFE_BLUE_BORDER = "rgba(24, 180, 232, 0.18)"
export const ZESTLIFE_ONBOARDING_TITLE = "#0e7aab"
export const ZESTLIFE_ONBOARDING_SUB = "#3aa0cc"
export const ZESTLIFE_ONBOARDING_HOVER_BG = "#d3effb"
/** rgba(24,180,232,0.22) — empty progress dots */
export const ZESTLIFE_DOT_EMPTY = "rgba(24, 180, 232, 0.22)"
export const ZESTLIFE_HEAD_NAME = "#1a1a1a"
export const ZESTLIFE_HEAD_ROLE = "#999999"
export const ZESTLIFE_ORG_LABEL = "#777777"
/** Cool-leaning red tuned to sit with ZestLife blues in dropdown actions */
export const ZESTLIFE_LOGOUT_RED = "#D14343"
/** Subtle red hover background for logout row */
export const ZESTLIFE_LOGOUT_RED_SOFT_BG = "#FDECEC"
